import { HelpDeskSectionTitle } from './HelpDeskSectionTitle';
import type { CardInfo, CustomAnswerInfo } from '@lub0v/santa-utils';
import { useTranslation } from 'react-i18next';
import { Badge } from '@src/components/Badge/Badge';
import { QuestionIcon } from '@src/components/icons/QuestionIcon';
import { OrganizerQuestionnaire } from '../BoxPage/full/OrganizerQuestionnaire';

export type HelpDeskQuestionnaireData = {
  answers: CustomAnswerInfo[];
  hiddenAnswers: NonNullable<CardInfo['hiddenAnswers']>;
};

export function HelpDeskQuestionnaire({
  data,
  participant,
  completed,
}: {
  data?: HelpDeskQuestionnaireData;
  participant: boolean;
  completed: boolean;
}) {
  const { t } = useTranslation();
  const hasQuestions = Boolean(data?.answers.length || data?.hiddenAnswers.length);
  if (!participant && !hasQuestions) return null;
  return (
    <section className="help-desk__field-group help-desk__questionnaire">
      <HelpDeskSectionTitle icon={<QuestionIcon />}>
        {t('admin.helpDesk.questionnaire')}
        <Badge tone={completed ? 'success' : 'neutral'}>
          {t(`admin.helpDesk.${completed ? 'setupCompleted' : 'setupNotCompleted'}`)}
        </Badge>
      </HelpDeskSectionTitle>
      <div className="help-desk__questionnaire-body">
        {hasQuestions ? (
          <OrganizerQuestionnaire
            card={{ customAnswers: data?.answers, hiddenAnswers: data?.hiddenAnswers }}
          />
        ) : (
          <p className="help-desk__questionnaire-empty">{t('admin.helpDesk.noAnswers')}</p>
        )}
      </div>
    </section>
  );
}
